export default __webpack_public_path__ + "locales/sk/Files.json?hash=3448a7c64ac888680bf088cecd493e25";